import Swiper from "../../../../../vendor/swiper/swiper-bundle.esm.browser";

export default class RealisationListSwiper {
    constructor($el) {
        this.$el = $el;
        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        var swiper = new Swiper(this.$el, {
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: this.$el.querySelector('[data-realisation-swiper-next]'),
                prevEl: this.$el.querySelector('[data-realisation-swiper-prev]'),
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1400: {
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                },
            },
        });
    }
}